export default __webpack_public_path__ + "static/media/4a1b445d05b05fba306fdcb3969ec9f91582286031094.1fbefda2.webp";